import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-max-16@2x.jpg";
import v3Image from "../../assets/Switching/professionalMax16.jpg";
import type { Product } from "../../types";
import { twoPointFiveTenGigabitEthernet } from "../product-groups/switching/2.5-10-gbe-1u";
import { professionalMax } from "../product-groups/twoPointFiveTenGigabitEthernet/professional-max";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professionalMax16: Product = {
  id: "professionalMax16",
  productTitle: "Pro Max 16",
  description: "professionalMax16.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-16"],
  storePathParts: {
    productSlug: "usw-pro-max-16",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
  },
  sku: "USW-Pro-Max-16",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 294,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  notes: ["professionalMax16.notes"],
  productGroup: twoPointFiveTenGigabitEthernet,
  secondaryProductGroup: professionalMax,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '325.1 x 160 x 43.7 mm\n(12.8 x 6.3 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "16 + 2 SFP+" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo2_5Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "professionalMax16.mounting",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
